export const config = {
    acceptAll: true,
    htmlTexts: true,
    purposes: {
        marketing: { title: "Marketing" },
        analytics: { title: "Statistiken" }
    },
    translations: {
        en: {
            privacyPolicyUrl: "https://www.mankiewicz.com/en/privacy-policy",
            "google-tag-manager": {
                title: "Google Tag Manager",
                description: "We use Google Tag Manager to manage website tags. It does not set cookies itself but may control services like Google Analytics that use cookies and process data. These services are only loaded with your consent.",
            },
            meta: {
                title: "Meta",
                description: "We use the Meta pixel to measure the success of marketing campaigns.",
            },
            linkedin: {
                title: "LinkedIn",
                description: "We use the LinkedIn pixel to measure the success of marketing campaigns.",
            },
            leadinfo: {
                title: "Leadinfo",
                description: "We use the Leadinfo pixel to measure the success of marketing campaigns.",
            },
            "google-analytics-4": {
                title: "Google Analytics 4",
                description: "We use Google Analytics to measure the success of marketing campaigns.",
            },
            youTube: {
                title: "YouTube",
                description: "We use YouTube to embed videos on our website.",
            },
            hubspot: {
                title: "HubSpot",
                description: "We use HubSpot to analyze website usage and optimize our marketing communications. This may involve the use of cookies. You can change your settings at any time.",
            },
            consentNotice: {
                description: "We use cookies on our website. Some of them are essential for the operation of the site, while others help us to improve this website and the user experience (tracking cookies). You can decide which cookies you allow. You can change your selection at any time in the <a href=\"https://www.mankiewicz.com/en/privacy-policy\" target=\"_blank\">privacy policy</a>. Please note that if you decline, you may no longer be able to use all the functions of the site.",
                learnMore: "Settings"
            },
            consentModal: {
                title: "Cookie settings",
                description: "Here you will find an overview of all cookies used. You can give your consent to entire categories. Or you can display further information and select only certain cookies."
            },
            ok: "Accept",
            decline: "Decline",
            purposes: {
                analytics: "Analytics",
                marketing: "Marketing",
                embeds: "Content from third parties",
            },
        },
        de: {
            privacyPolicyUrl: "https://www.mankiewicz.com/de/datenschutz",
            "google-tag-manager": {
                title: "Google Tag Manager",
                description: "Wir nutzen den Google Tag Manager zur Verwaltung von Website-Tags. Er setzt selbst keine Cookies, kann aber Dienste wie Google Analytics steuern, die Cookies verwenden und Daten verarbeiten. Diese werden nur mit Ihrer Einwilligung geladen.",
            },
            meta: {
                title: "Meta",
                description: "Wir nutzen den Meta-Pixel um den Erfolg von Marketing-Kampagnen zu messen.",
            },
            linkedin: {
                title: "LinkedIn",
                description: "Wir nutzen den LinkedIn-Pixel um den Erfolg von Marketing-Kampagnen zu messen.",
            },
            leadinfo: {
                title: "Leadinfo",
                description: "Wir nutzen den Leadinfo-Pixel um den Erfolg von Marketing-Kampagnen zu messen.",
            },
            "google-analytics-4": {
                title: "Google Analytics 4",
                description: "Wir nutzen den Google Analytics um den Erfolg von Marketing-Kampagnen zu messen.",
            },
            youTube: {
                title: "YouTube",
                description: "Wir nutzen YouTube um Videos auf unserer Seite einzubinden.",
            },
            hubspot: {
                title: "HubSpot",
                description: "Wir setzen HubSpot zur Analyse der Website-Nutzung und zur Optimierung unserer Marketing-Kommunikation ein. Dies kann das Setzen von Cookies beinhalten. Sie können Ihre Einstellungen jederzeit ändern.",
            },
            consentNotice: {
                description: "Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell für den Betrieb der Seite, während andere uns helfen, diese Website und die Nutzererfahrung zu verbessern (Tracking Cookies). Sie können entscheiden, welche Cookies Sie zulassen. Eine Änderung Ihrer Auswahl ist jederzeit in der <a href=\"https://www.mankiewicz.com/de/datenschutz\" target=\"_blank\">Datenschutzerklärung</a> möglich. Bitte beachten Sie, dass bei einer Ablehnung womöglich nicht mehr alle Funktionalitäten der Seite zur Verfügung stehen.",
                learnMore: "Einstellungen"
            },
            consentModal: {
                title: "Cookie-Einstellungen",
                description: "Hier finden Sie eine Übersicht über alle verwendeten Cookies. Sie können Ihre Einwilligung zu ganzen Kategorien geben. Oder Sie lassen sich weitere Informationen anzeigen und können so nur bestimmte Cookies auswählen."
            },
            ok: "Akzeptieren",
            decline: "Ablehnen",
            purposes: {
                analytics: "Besucherstatistiken",
                marketing: "Marketing",
                embeds: "Inhalte von Drittanbietern",
            },
        },
    },
    services: [
        {
            name: "youTube",
            purposes: ["embeds"],
        },
        {
            name: "google-tag-manager",
            required: false,
            purposes: ["marketing", "analytics"],
            onAccept: `
                // Trigger-loop for services
                for(let k of Object.keys(opts.consents)){
                    if (opts.consents[k]){
                        let eventName = 'klaro-'+k+'-accepted';
                        dataLayer.push({'event': eventName});
                    }
                }
            `, // load from config.yaml
            onInit: `
                window.dataLayer = window.dataLayer || [];
                window.gtag = function(){dataLayer.push(arguments)}
                // Consent Mode V2 DEFAULTS none allowed
                gtag('consent', 'default', {
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'analytics_storage': 'denied',
                    'wait_for_update': 500
                });
            `,
        },
        // --- SPEZIFISCHE DIENSTE (Steuern nur den Consent Status) ---
        {
            name: "meta",
            purposes: ["marketing"],
            onAccept: `
                gtag('consent', 'update', {
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
            `,
            onDecline: `
                gtag('consent', 'update', {
                  'ad_storage': 'denied',
                  'ad_user_data': 'denied',
                  'ad_personalization': 'denied'
                });
            `
        },
        {
            name: "linkedin",
            purposes: ["marketing"],
            onAccept: `
                gtag('consent', 'update', {
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
            `
        },
        {
            name: "leadinfo",
            purposes: ["marketing"],
            onAccept: `
                gtag('consent', 'update', {
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
            `
        },
        {
            name: "google-analytics-4",
            purposes: ["marketing"],
            onAccept: `
                gtag('consent', 'update', {
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
            `
        },
        {
            name: "hubspot",
            purposes: ["marketing"],
            onAccept: `
                gtag('consent', 'update', {
                  'analytics_storage': 'granted',
                  'ad_storage': 'granted',
                  'ad_user_data': 'granted',
                  'ad_personalization': 'granted'
                });
            `
        }
    ]
};
